export enum SkillsTypeEnum {
  LANGUAGE = "LANGUAGE",
  TECH = "TECH",
}

export enum LanguageLevelEnum {
  A1 = "A1",
  A2 = "A2",
  B1 = "B1",
  B2 = "B2",
  C1 = "C1",
  C2 = "C2",
}
export const CEFR_LEVELS: LanguageLevelEnum[] = [
  LanguageLevelEnum.A1,
  LanguageLevelEnum.A2,
  LanguageLevelEnum.B1,
  LanguageLevelEnum.B2,
  LanguageLevelEnum.C1,
  LanguageLevelEnum.C2,
];

export const minLevel = 0;
export const maxLevel = CEFR_LEVELS.length - 1;

export const messageFooter = [
  { level: "A1/A2", label: "Livello base" },
  { level: "B1/B2", label: "Livello intermedio" },
  { level: "C1/C2", label: "Livello avanzato" },
];

export const SKILL_KEYS = {
  LISTENING: "listening",
  READING: "reading",
  SPOKEN_INTERACTION: "spokenInteraction",
  SPOKEN_PRODUCTION: "spokenProduction",
  WRITTEN: "written",
};
